import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { motion } from 'framer-motion';
import { useScrollToElement } from '../hooks/useScrollToElement';

const CallToAction: React.FC = () => {
  const scrollToElement = useScrollToElement();

  return (
    <section className="py-20 text-white bg-dark-800">
      <div className="container px-4 mx-auto">
        <motion.div
          className="mx-auto max-w-3xl text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Zap size={48} className="mx-auto mb-6 text-primary-400" />
          <h2 className="mb-6 text-3xl font-bold md:text-4xl lg:text-5xl">Ready to Transform Your PC?</h2>
          <p className="mb-10 text-xl text-dark-300">
            Join thousands of satisfied users who have already supercharged their PC performance with WinMax Optimizer.
          </p>

          <div className="flex flex-col justify-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
            <Link
              to="/product/winmax-custom-duration"
              className="px-8 py-3 font-medium text-white rounded-md transition-colors bg-primary-500 hover:bg-primary-600"
            >
              Get Started Now
            </Link>
            <button
              onClick={() => scrollToElement('features')}
              className="px-8 py-3 font-medium text-white bg-transparent rounded-md border transition-colors border-dark-600 hover:bg-dark-700"
            >
              Learn More
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;